define('models/phone_number',['require','backbone','models/country'],function(require){

    var Backbone = require('backbone');

    var CountryModel = require('models/country');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                country: 0,
                number: '',
                country_object: new CountryModel().attributes
            };
        }
    });
});
